import { makeZoomLevelGreaterThan } from '../selectors/zoomLevelSelector'

const zoomLevelGreaterThan = makeZoomLevelGreaterThan()

const functions = {
  'RiverIcePointActive': state => zoomLevelGreaterThan(state, 12),
  'active': state => true
}

export default functions



// WEBPACK FOOTER //
// ./src/config/functions.js